import React, { useCallback } from 'react';

import { Globe, Lock } from 'lucide-react';
import { SegmentedControl } from 'src/components/generic/segmented-control';

import type { ActivityLane } from './use-activity-lane';
import { ACTIVITY_LANE } from './use-activity-lane';

const LANE_OPTIONS = [
  { icon: Lock, label: 'Team', value: ACTIVITY_LANE.Team },
  { icon: Globe, label: 'External', value: ACTIVITY_LANE.External },
] as const;

interface ActivityLaneSwitchProps {
  lane: ActivityLane;
  onChange: (lane: ActivityLane) => void;
  ariaLabel?: string;
}

/** Picks which side of a task is on screen: the team's own, or the one shared outside. */
export const ActivityLaneSwitch = React.memo(function ActivityLaneSwitch({
  ariaLabel = 'Activity lane',
  lane,
  onChange,
}: ActivityLaneSwitchProps) {
  const handleChange = useCallback(
    (value: string) => {
      const next = LANE_OPTIONS.find(option => option.value === value);
      if (next) onChange(next.value);
    },
    [onChange]
  );

  return (
    <SegmentedControl
      ariaLabel={ariaLabel}
      options={LANE_OPTIONS}
      value={lane}
      onChange={handleChange}
    />
  );
});
